module.exports = __webpack_public_path__ + "static/img/14000039.e052556f.png";